import { FC, useContext } from "react";
import FooterText from "../../components/footerText";
import AuthSubHeader from "../../components/authSubHeader";
import { AuthContext } from "src/context/authContext";
import { TextAlignProps } from "src/components/contactAndSafetyInfo/types";
import ManufacturerContactAndSafetyInfo from "src/components/manufacturer/manufacturerContactAndSafetyInfo";
import buybillbadge from "../../assets/images/buybillbadge.png";



const InstructionSubmittingClaim: FC = (): JSX.Element => {

  const { isManufacturer, isUserAuthorized } = useContext(AuthContext);

  return (
      <div className="overflow-y-auto overflow-x-hidden d-flex flex-column flex-fill">
          {isUserAuthorized &&
              <div className="bg-mist py-2">
                  <div className="container-fluid">
                      {isManufacturer ?
                          <ManufacturerContactAndSafetyInfo textColor="black" alignText={TextAlignProps.TEXT_END} /> :
                          <AuthSubHeader />
                      }
                  </div>
              </div>
          }

          <div className="container py-5 d-flex flex-column flex-fill copay-modal" style={{maxWidth: "1200px"}}>

              <h3 className="color-orange">Co-Pay Program Claim Filing Directions</h3>
              <h6 className="mb-4 fw-semibold">
                  Filing a ZILRETTA Co-Pay claim is quick and easy! There are 2 ways your practice can file a claim:
              </h6>
              <ol>
                  <li>
                      <b>Directly/electronically through your billing software’s workflow via Electronic Data Interchange</b>
                      -simply send a secondary claim to payer ID PSKW0. For more information on the electronic claims
                      process including how to set up your practice
                      &nbsp;<a data-bs-toggle="collapse" href="#collapseClaim">
                          click here <i className="bi bi-chevron-expand"></i>
                      </a>
                      <div className="collapse mt-3" id="collapseClaim">
                          <div className="card card-body p-4">
                              <div>
                                  <img style={{maxWidth:"150px", float:"right", marginTop:"-25px"}} src={buybillbadge} alt="ZilrettaLogo"/>
                                  <h4 className="fw-bold color-orange">SIMPLIFYING ENROLLMENT AND REIMBURSEMENT: BUY & BILL</h4>
                                  <h3 className="my-3">The ZILRETTA Co-Pay Program Process Flow- NEW, EDI OPTION</h3>
                                  <h6 className="text-center fw-semibold my-3 bg-iovera text-white rounded-3 p-2">
                                      I want to use my Practice’s Billing Software
                                  </h6>
                              </div>
                              <p className="fw-bold mb-1">1. Getting Started</p>
                              <ul style={{lineHeight:"2"}}>
                                  <li>In your practice management software, select <b>PSKW0</b> as a payer.</li>
                                  <li>
                                      If Payer ID <b>PSKW0</b> is not available, contact your software vendor and/or clearinghouse to
                                      request the addition of Payer ID <b>PSKW0</b> to the system.
                                      <br/>
                                      <i>The process of adding a new payer to a practice management software or clearinghouse varies by vendor.
                                          Please work directly with your vendor’s customer support team if you require assistance.
                                      </i>
                                  </li>
                                  <li>
                                      When Payer ID <b>PSKW0</b> is available in your system, you are ready to submit electronic claims
                                      transactions (EDI 837 files).
                                  </li>
                              </ul>

                              <p className="fw-bold mb-1">2. Submit Claims via EDI</p>
                              <ul style={{lineHeight:"2"}}>
                                  <li>Add Zilretta Copay Program to your patient’s insurance profile as a secondary payer.</li>
                                  <li>
                                      When adding Zilretta Copay Program to the patient’s profile, be sure to include the following
                                      required information:
                                      <ul>
                                          <li>Payer ID: <b>PSKW0</b></li>
                                          <li>Program Group Number: EC47002001</li>
                                          <li>Patient Member ID: Unique patient identifier found on the program approval letter</li>
                                      </ul>
                                  </li>
                                  <i>Failure to include this information will result in your claim being rejected.</i>
                              </ul>

                              <p className="fw-bold mb-4">
                                  3. Submit a request to your clearing house to accept ERA transactions
                                  (EDI 835 files) from Payer ID <b>PSKW0</b>.
                              </p>

                              <p className="fw-bold mb-1">4. To receive ERAs please follow the instructions below:</p>
                              <ul style={{lineHeight:"2"}}>
                                  <li>Request your clearing house to create an account with the ConnectiveRX clearing house: Claim.MD
                                      <ol>
                                          <li>Website: <a href="https://www.claim.md/" target="_blank">www.claim.md</a> </li>
                                          <li>Login to your Claim.MD account
                                              <ul>
                                                  <li>Click Provider Enrollment</li>
                                                  <li>Add or select an NPI/Tax ID</li>
                                                  <li>Search for Payer ID. Under the ERA column, click "Quick Enroll“</li>
                                              </ul>
                                          </li>
                                          <li>Customer service phone number for Claim.MD: 1-855-757-6060</li>
                                          <li>Clearing house can contact: Linda Sheer 1-855-757-6060 EXT 490 for enrollment help with ERAs</li>
                                          <li>
                                              When the request is complete, you should begin to receive ERAs for claims submitted via
                                              EDI ~ 5 to 7 business days from the date of claims submission.
                                          </li>
                                      </ol>
                                  </li>
                              </ul>
                          </div>
                      </div>
                      <br />
                      <b>OR</b>
                  </li>
                  <li>
                      <b>Uploading the EOB/EOP to the FlexForward Portal.</b>
                      &nbsp;Once your practice has received the Explanation of Benefit or Payment (EOB/EOP) from the patient’s
                      insurance company please upload it and the submitted claim (CMS 1500 or UB04) to FlexForward.
                      In the Next Steps column below there will be a “Copay Claim” button for easy upload. Please allow
                      8-15 business days for reimbursement after submitting co-pay claim to FlexForward.
                  </li>
              </ol>
          </div>
          <FooterText footerType="black" />
      </div>
  );
};

export default InstructionSubmittingClaim;


